import React, { Component } from 'react';
import MaskArea from './MaskArea'

class FloatWindow extends Component {
    constructor(props){
        super(props)
        this.state={
            position:{
                x:0,
                y:0,
            },
            refPos:{
                x:0,
                y:0
            },
            divSize:{
                width:0,
                height:0,
            },
            refDivSize:{
                width:0,
                height:0
            },

            containerExtending:false,
            containerDragging:false,
        }
    }

    componentDidMount(){
        //console.log("FloatWindow componentDidMount...")
        if(this.props.initialSize && this.props.initialPos)
        {
            this.setState({
                position:this.props.initialPos,
                divSize:this.props.initialSize
            })
        }
        else if(this.props.initialSize && !this.props.initialPos)
        {
            this.setState({
                divSize:this.props.initialSize
            })
        }
    }

    componentDidUpdate(prevProps, prevState) {
        //console.log('FloatWindow componentDidUpdate...')
         
        if(this.state.containerExtending === false && this.state.containerDragging === true)
        {
            //console.log("A")
            if(prevProps.mousePos !== this.props.mousePos)
            {
                this.setNewContainerPosition()
            } 
        }
        else if(this.state.containerExtending === true && this.state.containerDragging === false)
        {
            //console.log("B")
            if(prevProps.mousePos !== this.props.mousePos)
            {
                this.setNewContainerSize()
            } 
        }
        else if(this.state.containerExtending === false && this.state.containerDragging === false)
        {
            if(prevProps.initialSize && this.props.initialSize)
            {
            //console.log("C")
            if(prevProps.initialSize.width !== this.props.initialSize.width || prevProps.initialSize.height !== this.props.initialSize.height)
            {
                
                //console.log("D")
                this.setState({
                    divSize:this.props.initialSize
                })
            }
            //console.log("E")
            }
        }
    }

    setNewContainerPosition() {
        let containerX = this.props.mousePos.x-this.state.refPos.x
        let containerY = this.props.mousePos.y-this.state.refPos.y
        let newPos = {
            x:containerX,
            y:containerY
        }

        this.setState({
            position:this.borderCollisonForMoving(newPos),
            containerFocusing:true
        })
    }

    setNewContainerSize=()=>{

        let width = this.state.refDivSize.width+(this.props.mousePos.x-this.state.refPos.x)
        let height = this.state.refDivSize.height+(this.props.mousePos.y-this.state.refPos.y)
       
        let newSize = {
            width:width,
            height:height
        }
   
        this.setState({
            divSize: this.borderCollisonForExtending(newSize) ,
            containerFocusing:true
        })
       
    }

    borderCollisonForMoving=(pos)=>{
        if(pos.x<0)
        {
            pos.x=0
        }

        if(pos.x+this.state.divSize.width>this.props.dynamicImageSize.width)
        {
            pos.x=this.props.dynamicImageSize.width-this.state.divSize.width
        }

        if(pos.y<0)
        {
            pos.y=0
        }

        if(pos.y+this.state.divSize.height>this.props.dynamicImageSize.height)
        {
            pos.y=this.props.dynamicImageSize.height-this.state.divSize.height
        }

        return pos

    }

    borderCollisonForExtending=(size)=>{
        if(size.width+this.state.position.x>this.props.dynamicImageSize.width)
        {
            size.width = this.props.dynamicImageSize.width-this.state.position.x
        }

        if(size.height+this.state.position.y>this.props.dynamicImageSize.height)
        {
            size.height = this.props.dynamicImageSize.height-this.state.position.y
        }

        return size

    }

    extendAreaMouseDown=(e)=>{
        // console.log('extendAreaMouseDown')
        e.stopPropagation()
        this.setState({
            containerExtending:true,
            containerFocusing:true,
            refPos:{
                x:e.clientX,
                y:e.clientY
            },
            refDivSize:this.state.divSize
        })   

        let msg ={
            conID:1,
            containerExtending:true,
        }
        this.props.containerExtending(msg)
    }

    extendAreaMouseUp=(e)=>{
        e.stopPropagation()
        this.setState({
            containerExtending:false,
            refPos:{
                x:0,
                y:0
            },
        })  

        let msg ={
            conID:1,
            containerExtending:false,
            size:this.state.divSize,
        }
        //console.log("D0")
      
        this.props.containerExtending(msg)
    }

    headerMouseDown=(e)=>{   
        e.stopPropagation()
        e.preventDefault()
        //console.log('ControllerUnitContainer headerMouseDown')
        this.setState({
            containerDragging:true,
            containerFocusing:true,
            refPos:{
                x:e.clientX-this.state.position.x,
                y:e.clientY-this.state.position.y
            }
        })   

        let msg ={
            containerDragging:true,
        }
        this.props.containerDragging(msg)
        
    }

    headerMouseUp=(e)=>{
        e.stopPropagation()
        this.setState({
            containerDragging:false,
            refPos:{
                x:0,
                y:0
            },
        })  

        let msg ={
            containerDragging:false,
            position:this.state.position,
        }
        this.props.containerDragging(msg)
    }

    render(){
        //console.log("FloatWindow render...")
        //console.log("props :")
        //console.log(this.props.initialSize)
        //console.log("state :")
        //console.log(this.state.divSize)
        let focusingCompositionContainerStyle ={
            width:this.state.divSize.width,
            height:this.state.divSize.height,
            position:'absolute',
            left:this.state.position.x,
            top:this.state.position.y,
            zIndex:1300,
            border:'3px dashed',
            borderColor:'#fff838',
            boxSizing:'border-box',
            display: 'flex',
            flexDirection: 'column',
            cursor:'move'
        }

        const extendFunctionAreaStyle = {
            width:'20px',
            height:'20px',
            position:'absolute',
            right:'0px',
            bottom:'0px',
            userSelect:'none',
            color:"#fff838",
            cursor:'nw-resize'
        }

        let defaultImageLayout={
            width:this.props.dynamicImageSize.width,
            height:this.props.dynamicImageSize.height
        }


        return(       
            <div style={defaultImageLayout} >
                <div style={focusingCompositionContainerStyle} onMouseDown={this.headerMouseDown} onMouseUp={this.headerMouseUp}>  
                    <div style={extendFunctionAreaStyle} onMouseDown={this.extendAreaMouseDown}  onMouseUp={this.extendAreaMouseUp}>
                        &#9499;
                    </div> 
                </div>
                <MaskArea dynamicImageSize={this.props.dynamicImageSize} floatWinPos={this.state.position} floatWinSize={this.state.divSize}/>
            </div>
        )
    }
}

export default FloatWindow